import { useCallback } from 'react';

import { useProjectSiteParams } from '@/shared/lib';

import { useRejectServiceRequestMutation } from '../api';
import type { ServiceRequestRejectRequest, ServiceRequestActionResult } from './types';

export interface RejectServiceRequestParams {
  onSuccess?: (data: ServiceRequestActionResult) => void;
  onError?: (error: unknown) => void;
}

export const useRejectServiceRequest = ({ onSuccess, onError }: RejectServiceRequestParams) => {
  const { projectId, siteId } = useProjectSiteParams();
  const [rejectRequest, { isLoading, isSuccess, isError, error, data }] = useRejectServiceRequestMutation();

  const handleReject = useCallback(
    async ({ id, rejectComment, rejectReason }: ServiceRequestRejectRequest) => {
      try {
        const response = await rejectRequest({
          id,
          projectId,
          siteId,
          rejectComment,
          rejectReason
        }).unwrap();

        onSuccess?.(response);
        return response;
      } catch (error) {
        onError?.(error);
        throw error;
      }
    },
    [rejectRequest, onSuccess, onError, projectId, siteId]
  );

  return {
    rejectServiceRequest: handleReject,
    isLoading,
    isSuccess,
    isError,
    error,
    data
  };
};
